import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
  Divider,
  makeStyles
} from "@fluentui/react-components";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import PropTypes from "prop-types";
import { ResetButton } from "./ResetButton";

const useStyles = makeStyles({
  accordionPanel: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginBottom: "20px"
  },
  accordionRow: {
    display: "flex",
    minHeight: "var(--lineHeightBase600, 32px)",
    gap: "10px",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch"
  },
  accordionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%"
  }
});

export function ControlsSettings({
  movementChildren,
  touchscreenChildren,
  onResetToDefaultMovement,
  onResetToDefaultTouchscreen
}) {
  const intl = useIntl();
  const styles = useStyles();

  return (
    <div>
      <Accordion collapsible multiple defaultOpenItems={["1", "2"]}>
        <AccordionItem value="1">
          <AccordionHeader>
            <div className={styles.accordionHeader}>
              <FormattedMessage id="room-settings-sidebar.movement-settings" defaultMessage="Movement" />
              <ResetButton onClick={onResetToDefaultMovement} />
            </div>
          </AccordionHeader>
          <AccordionPanel className={styles.accordionPanel}>{movementChildren}</AccordionPanel>
        </AccordionItem>
        <Divider />
        <AccordionItem value="2">
          <AccordionHeader>
            <div className={styles.accordionHeader}>
              <span>
                {intl.formatMessage({
                  id: "room-settings-sidebar.touchscreen-settings",
                  defaultMessage: "Touchscreen"
                })}
              </span>
              <ResetButton onClick={onResetToDefaultTouchscreen} />
            </div>
          </AccordionHeader>
          <AccordionPanel className={styles.accordionPanel}>{touchscreenChildren}</AccordionPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
}

// Add proptypes
ControlsSettings.propTypes = {
  movementChildren: PropTypes.node,
  touchscreenChildren: PropTypes.node,
  onResetToDefaultMovement: PropTypes.func,
  onResetToDefaultTouchscreen: PropTypes.func
};
